/*
 * Aviso de cookies - Riva Esencia (Shrine)
 * Implementa consentimiento GRANULAR usando la Customer Privacy API oficial de Shopify:
 * https://shopify.dev/docs/api/consent-tracking
 * No depende de ninguna librería ni app de terceros.
 */
(function () {
  if (window.__rivaCookieBannerInit) return;
  window.__rivaCookieBannerInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var banner = document.getElementById('CookieBanner');
    if (!banner) return;

    var delay = parseInt(banner.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 5;

    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    var declineBtn = banner.querySelector('[data-cookie-decline]');
    var visible = false;
    var timer = null;

    function show() {
      if (visible) return;
      visible = true;
      banner.removeAttribute('hidden');
      banner.setAttribute('aria-hidden', 'false');
      // Forzar reflow para que la transición de opacidad se aplique
      void banner.offsetWidth;
      banner.classList.add('cookie-banner--visible');
    }

    function hide() {
      visible = false;
      banner.classList.remove('cookie-banner--visible');
      banner.setAttribute('aria-hidden', 'true');
      banner.setAttribute('hidden', '');
    }

    function scheduleShow() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(show, delay * 1000);
    }

    function needsDecision(consent) {
      // currentVisitorConsent() devuelve '' cuando el visitante aún no ha decidido esa categoría
      return consent.marketing === '' || consent.analytics === '' || consent.preferences === '';
    }

    function setConsent(accepted) {
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          marketing: accepted,
          analytics: accepted,
          preferences: accepted,
        },
        function () {
          document.dispatchEvent(new CustomEvent('rivaCookieConsentSet', { detail: { accepted: accepted } }));
        }
      );
    }

    function initBanner() {
      if (!window.Shopify || !window.Shopify.customerPrivacy) return;
      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      if (needsDecision(consent)) {
        scheduleShow();
      }
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        if (timer) clearTimeout(timer);
        hide();
        setConsent(true);
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        if (timer) clearTimeout(timer);
        hide();
        setConsent(false);
      });
    }

    // Permite volver a abrir el banner más adelante (p. ej. desde un enlace de
    // "preferencias de cookies" que se añada en otra sección del tema).
    window.rivaOpenCookiePreferences = function () {
      if (timer) clearTimeout(timer);
      show();
    };

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
            onLoad: function (error) {
              if (error) return;
              initBanner();
            },
          },
        ]
      );
    }
  });
})();
